import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import { clearVehicleData, clearVehicleList } from './vehicle';

import { loadBrowserState, saveBrowserState } from '../../utils/localStorage';

const BRAND_NAME_IN_LOCAL_STORAGE = 'drivecloud_currentBrand';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  // vehicleData: null
  currentBrand: '',
  availableBrands: [],
  availableBrandsDisplayNames: [],
  brandList: [],
  selectedBrand: null,
  selectedBrandList: []
};

const slice = createSlice({
  name: 'brand',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      console.debug(action);
      state.error = true;
    },

    // // GET AVAILABLE BRANDS
    // getAvailableBrandsSuccess(state, action) {
    //   state.isLoading = false;
    //   state.availableBrands = action.payload;
    // },

    // SET BRAND
    setCurrentBrandSuccess(state, action) {
      state.isLoading = false;
      const brandCurrent = action.payload;
      state.currentBrand = brandCurrent;
      /* save chosen brand in browser's locale storage */
      saveBrowserState(BRAND_NAME_IN_LOCAL_STORAGE, brandCurrent);
      /* update selectedBrandList if it's empty */
      if (state.selectedBrandList.length < 1)
        state.selectedBrandList = [brandCurrent];
      /* reset cached data */
      clearVehicleData();
      clearVehicleList();
    },

    setSelectedBrandListSuccess(state, action) {
      state.isLoading = false;
      state.selectedBrandList = action.payload;
      /* reset cached data */
      clearVehicleData();
      clearVehicleList();
    },

    getBrandSuccess(state, action) {
      state.isLoading = false;
      state.selectedBrand = action.payload;
    },

    getBrandListSuccess(state, action) {
      state.isLoading = false;
      const brandOptions = action.payload;
      state.brandList = brandOptions;
      if (brandOptions && brandOptions.length > 0) {
        const brandNameList = brandOptions.map((brand) => brand.name);
        const brandDisplayNameList = brandOptions.map((brand) => ({
          name: brand.name,
          brandDisplayName: brand.brandDisplayName || ''
        }));
        state.availableBrands = brandNameList;
        state.availableBrandsDisplayNames = brandDisplayNameList;

        /* set currentBrand as the last chosen brand saved in browser's locale storage 
          if such brand is present in user's brandList
          or as a first element from the brandList */
        const brandInStorage = loadBrowserState(BRAND_NAME_IN_LOCAL_STORAGE);
        // // console.debug('brandInStorage = ', brandInStorage);
        if (brandInStorage && brandNameList.includes(brandInStorage)) {
          state.currentBrand = brandInStorage;
        } else {
          const index = 0;
          state.currentBrand = brandNameList[index];
        }
      }
    },

    createBrandSuccess(state, action) {
      state.isLoading = false;
    },

    clearBrandDataSuccess(state) {
      state.availableBrands = [];
      state.availableBrandsDisplayNames = [];
      state.brandList = [];
      state.selectedBrand = initialState.selectedBrand;
    },
    deleteBrandSuccess(state, action) {
      state.isLoading = false;
    }
  }
});

// Reducer
export default slice.reducer;

// // Actions
// export const { onToggleFollow } = slice.actions;

// ----------------------------------------------------------------------

// export function getAvailableBrands() {
//   console.debug('getAvailableBrands()');
// }

// ----------------------------------------------------------------------

export function getBrandList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `query {
          getBrandList
             {
                name,
                brandDisplayName,
                dealerId,
                company,
                websiteSlug,
                salesforceUrl,
                numberOfBranches,
                dateCreated,
             }
        }`;

      const response = await axios.post('/graphql', { query: queryString });
      dispatch(
        slice.actions.getBrandListSuccess(response.data.data.getBrandList)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function setCurrentBrand(brand) {
  console.debug('setCurrentBrand(): brand = ', brand);
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.setCurrentBrandSuccess(brand));
  };
}

export function setSelectedBrandList(brandList) {
  console.debug('setSelectedBrandList(): brandList = ', brandList);

  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    dispatch(slice.actions.setSelectedBrandListSuccess(brandList));
  };
}

export function getBrand(brand) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    brand = JSON.stringify(brand);

    try {
      const queryString = `query {
        getBrand(name:${brand})
           {
              name,
              brandDisplayName,
              apiKey,
              company,
              websiteSlug,
              salesforceUrl,
              dateCreated,
              lastUpdated
           }
      }`;

      const response = await axios.post('/graphql', { query: queryString });
      dispatch(slice.actions.getBrandSuccess(response.data.data.getBrand));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function createBrand(values) {
  try {
    const queryString = `mutation {
      createBrand(
          name:${JSON.stringify(values.name)}, 
          apiKey:${JSON.stringify(values.apiKey)}, 
          company:${JSON.stringify(values.company)},
          websiteSlug:${JSON.stringify(values.websiteSlug)}, 
          salesforceUrl:${JSON.stringify(values.salesforceUrl || '')}
        )
        {
            name
        }
      }`;

    const response = await axios.post('/graphql', { query: queryString });

    if (response.data.errors && response.data.errors.length > 0)
      throw new Error(response.data.errors[0].message);

    slice.actions.createBrandSuccess(response.data);
  } catch (error) {
    console.log(error);
    slice.actions.hasError(error);
    throw new Error(error);
  }
}

export function deleteBrand(brand) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const queryString = `mutation { 
        deleteBrand(name: "${brand}")
      }`;

      const response = await axios.post('/graphql', { query: queryString });

      if (response.data.errors && response.data.errors.length > 0)
        throw new Error(response.data.errors[0].message);

      dispatch(slice.actions.deleteBrandSuccess(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw new Error(error);
    }
  };
}

export function clearBrandData() {
  return async (dispatch) => {
    dispatch(slice.actions.clearBrandDataSuccess());
  };
}

export async function updateBrand(
  values
  // turnOffAdvertsWhenStockIsSold
) {
  // return async (dispatch) => {
  // dispatch(slice.actions.startLoading());
  try {
    const queryString = `mutation {
          updateBrand( 
            name:${JSON.stringify(values.name)}, 
            brandDisplayName:${JSON.stringify(values.brandDisplayName)}
            apiKey:${JSON.stringify(values.apiKey)}, 
            websiteSlug:${JSON.stringify(values.websiteSlug)}, 
            salesforceUrl:${JSON.stringify(values.salesforceUrl || '')}, 
            dateCreated:${JSON.stringify(values.dateCreated)}, 
            company:${JSON.stringify(values.company)}
          ) {
              name,
              brandDisplayName
          }
        }`;

    const response = await axios.post('/graphql', { query: queryString });
    console.debug(response);
    // dispatch(slice.actions.createBrandSuccess(response.data));
  } catch (error) {
    slice.actions.hasError(error);
  }
}
